import { FlexView, Text, Icon } from '@components/Common';
import languages from '@locales/languages';
import { Colors } from '@styles/system';

import ModalM from './ModalM';

interface ModalProps {
  language: 'ko' | 'en';
  closePortal: () => void;
}

export default ({ language, closePortal }: ModalProps) => {
  const TEXTS = languages[language].modal;

  // const wrapperCSS = {
  //   backgroundColor: Colors.gray700,
  //   borderRadius: `8px`,
  //   width: `152px`,
  //   minHeight: `60px`,
  //   display: `flex`,
  //   alignItems: `center`,
  //   justifyContent: `center`,
  // };

  return (
    <ModalM closePortal={closePortal} color="#141414" close>
      <FlexView
        css={{
          minHeight: 0,
          padding: `20px 8px 24px`,
          overflowY: `auto`,
          scrollbarWidth: `none`,
          '::-webkit-scrollbar': { display: `none` },
        }}
        fill
      >
        {/* 기존 앱 다운로드 안내 문구 (롤백 대비 보존)
        <FlexView css={{ margin: `24px 0 40px 0` }}>
          <Text color={Colors.secondary70} center multiLine>
            {TEXTS.downloadGuideM}
          </Text>
        </FlexView> */}

        {/* 기존 앱 스토어 다운로드 버튼 (롤백 대비 보존)
        <FlexView content="center" gap={24} row>
          <Anchor
            css={wrapperCSS}
            href="https://apps.apple.com/us/app/blockchat/id1635256021"
            referrerPolicy="no-referrer"
            target="_blank"
          >
            <Icon color={Colors.white} name="appStore" size={24} />
          </Anchor>
          <Anchor
            css={wrapperCSS}
            href="https://play.google.com/store/apps/details?id=com.blockchainlabs.android"
            referrerPolicy="no-referrer"
            target="_blank"
          >
            <Icon color={Colors.white} name="googlePlay" size={20} />
          </Anchor>
        </FlexView> */}

        {/* 기존 안내 사항 및 문의 문구 (롤백 대비 보존)
        <FlexView
          css={{
            padding: `24px 0 40px 0`,
            margin: `32px 0 40px 0`,
            borderTop: `1px solid ${Colors.secondary20}`,
            borderBottom: `1px solid ${Colors.secondary20}`,
          }}
          gap={24}
          items="center"
        >
          <Text color={Colors.secondary} medium>
            {TEXTS.notice}
          </Text>
          <FlexView gap={20} items="center">
            <FlexView css={{ width: `100%` }} gap={12} row>
              <Text color={Colors.secondary70} css={{ lineHeight: `150%` }}>
                1.
              </Text>
              <Text color={Colors.secondary70} fill multiLine small>
                {TEXTS.notice1}
              </Text>
            </FlexView>
          </FlexView>
        </FlexView>
        <FlexView gap={4} items="center">
          <Text color={Colors.secondary70} center multiLine>
            {TEXTS.adviceM}
          </Text>
          <Text color={Colors.primary} center>
            {TEXTS.email}
          </Text>
        </FlexView> */}

        <FlexView gap={12} items="start">
          <Icon color={Colors.primary} name="logo" size={24} />
          <Text color={Colors.secondary} large multiLine semiBold>
            {TEXTS.serviceEndTitle}
          </Text>
        </FlexView>

        <FlexView css={{ marginTop: `24px` }} gap={18}>
          <Text color={Colors.secondary70} multiLine small>
            {TEXTS.serviceEndGreeting}
          </Text>
          <Text color={Colors.secondary70} multiLine small>
            {TEXTS.serviceEndThanks}
          </Text>
          <Text color={Colors.secondary} multiLine semiBold small>
            {TEXTS.serviceEndDate}
          </Text>
          <Text color={Colors.secondary} multiLine semiBold small>
            {TEXTS.serviceEndAvailability}
          </Text>
          <Text color={Colors.secondary} multiLine semiBold small>
            {TEXTS.serviceEndDataDisposal}
          </Text>
          <Text color={Colors.secondary70} multiLine small>
            {TEXTS.serviceEndNoStoredData}
          </Text>
          <Text color={Colors.secondary70} multiLine small>
            {TEXTS.serviceEndClosing}
          </Text>
          <FlexView gap={4}>
            <Text color={Colors.secondary70} multiLine small>
              {TEXTS.serviceEndContact}
            </Text>
            <Text color={Colors.primary} semiBold small>
              {TEXTS.serviceEndContactEmail}
            </Text>
          </FlexView>
        </FlexView>
      </FlexView>
    </ModalM>
  );
};
